import * as React from 'react';
import MDSpinner, { MDSpinnerProps } from 'react-md-spinner';

export const Loader: React.SFC<MDSpinnerProps> = props => <MDSpinner {...props} />;
